import { useMemo } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import { getVouchersTemplateAPI, postCreateVouchersAPI } from "api/campaign-voucher";
import { VoucherCreateFormTypes } from "schemas/campaign-voucher-schemas";
import { QUERY_KEYS } from "constants/querykeys";
import { toast } from 'react-toastify';

export const useVouchersQuery = () => {
  const queryKey = [QUERY_KEYS.VOUCHER_LIST]
  const queryFn = async () => {
    return await getVouchersTemplateAPI()
  }
  const queryOptions = {
    refetchOnWindowFocus: false,
    queryKey,
    queryFn,
  }
  const query = useQuery(queryOptions)

  const vouchersOptions = query.data
    ? query.data.data.map((item) => ({
      label: item.voucherName,
      value: String(item.voucherName),
    }))
    : []

  return {
    query,
  }
}

export const useVouchersMutation = () => {
  const { mutateAsync } = useMutation({
    mutationFn: getVouchersTemplateAPI,
    mutationKey: [QUERY_KEYS.REPORT_MERCHANT_SEARCH],
  });

  const onSearchVouchersLoader = async (inputValue: string) => {
    const data = await mutateAsync();
    return data.data
      .filter((c) =>
        c.voucherName.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((c) => ({
        label: c.voucherName,
        value: c.voucherName,
      }));
  };

  return {
    onSearchVouchersLoader,
  }
}

export const useVouchersSelectQuery = () => {
  const { query } = useVouchersQuery()

  const voucherOptions = useMemo(() => {
    const data = query.data?.data || []
    return data.map((item) => ({
      label: item.voucherName,
      value: String(item.voucherName),
    }))
  }, [query.data])

  return { voucherOptions }
}

export const useVoucherCreate = () => {
  const queryClient = useQueryClient();

  const mutationFn = (mutationData: { formData: VoucherCreateFormTypes }) => {
    const { formData } = mutationData;
    return postCreateVouchersAPI(formData);
  };

  const mutation = useMutation({
    mutationFn,
    onError: (error: string) => {
      const message = JSON.parse(JSON.stringify(error))
      toast.error(`${message.outcomeMessage || 'Failed to create voucher.'}`)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === QUERY_KEYS.VOUCHER_LIST
      })
    },
  });

  return mutation;
};
